<template>
  <div class="execute-form atb-flex atb-flex-column">
    <div class="atb-content-bg atb-flex atb-flex-column">
      <div class="search">
        <el-form :inline="true" :model="searchParam" class="atb-input" @keyup.enter.native.prevent="getList(1)" @submit.native.prevent>
          <el-form-item class="flex-form-item" label="部门名称" prop="departmentNo">
            <el-popover placement="bottom-start" width="420" popper-class="popper-tree declare-dep" @hide="handledHide" trigger="click">
              <el-tree
                :props="defaultProps"
                :data="treeData"
                show-checkbox
                node-key="id"
                ref="tree"
                highlight-current
                check-strictly
                :default-expanded-keys="expandedData"
                :filter-node-method="filterDeptNode"
                @check-change="handleCheckChange"
              >
              </el-tree>
              <el-input slot="reference" v-model="department" placeholder="请选择部门名称" clearable></el-input>
            </el-popover>
          </el-form-item>
          <el-form-item label="人员姓名">
            <selecter v-model="searchParam.WkName"></selecter>
          </el-form-item>
          <!-- <el-form-item label="日期">
            <el-date-picker
              v-model="searchParam.Date"
              value-format="yyyy-MM-dd"
              align="right"
              type="date"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item> -->
          <el-form-item label="日期">
            <el-date-picker
              v-model="searchParam.FinishDate"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="数据权限" prop="AuthType">
            <el-select v-model="searchParam.AuthType" placeholder="">
              <el-option v-for="item in authTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList(1)">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="export" v-if="$auth(that, 'ExecuteFormExport')" @click="exportExcel">导出</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-content atb-flex atb-flex-column">
        <vxe-table
          class="atb-table header-table edit-table"
          border="inner"
          height="100%"
          auto-resize
          resizable
          stripe
          highlight-hover-row
          highlight-current-row
          :data="tableData"
          ref="executeForm"
          @cell-click="expandRow"
        >
          <vxe-table-column type="checkbox" width="60"></vxe-table-column>
          <vxe-table-column type="seq" width="60" title="序号"></vxe-table-column>
          <vxe-table-column field="wkNo" width="80" title="工号"></vxe-table-column>
          <vxe-table-column field="wkName" width="150" title="姓名">
            <template #default="{row}">
              <span class="table-link" @click.stop="openOEC(row)">{{ row.wkName }}</span>
              <!-- <el-link :underline="false" type="success" @click.stop='openOEC(row)'>{{row.wkName}}</el-link> -->
            </template>
          </vxe-table-column>
          <vxe-table-column field="department" min-width="220" title="部门"></vxe-table-column>
          <vxe-table-column field="title" min-width="250" title="执行表格">
            <!-- <template #default="{row}">
                 <el-link :underline="false" class="plan_table" type="success" v-for="item in JSON.parse(row.executedTitle||[])" :key="item.WorkId" :label="item.Title" :value="item.WorkId" @click.stop='openTable(item)'>{{'&lt;&lt;' + item.Title + '&gt;&gt;'}}</el-link>
            </template> -->
            <template #default="{ row }">
               <span
                class="table-link"
                v-if="!row.expandRowFlag"
                @click.stop="openTable(JSON.parse(row.executedTitle || [])[0])"
                >{{JSON.parse(row.executedTitle || []).length > 1 ? '&lt;&lt;' + JSON.parse(row.executedTitle || [])[0].Title +  '&gt;&gt;' + "..." : JSON.parse(row.executedTitle || []).length === 1 ? '&lt;&lt;' + JSON.parse(row.executedTitle || [])[0].Title +  '&gt;&gt;' : ""}}</span
              >
              <div v-else>
                <span
                  class="table-link"
                  v-for="item in JSON.parse(row.executedTitle || [])"
                  :key="item.WorkId"
                  :label="item.Title"
                  :value="item.WorkId"
                  @click.stop="openTable(item)"
                  >{{ '&lt;&lt;' + item.Title + '&gt;&gt;' }}</span
                >
              </div>
              <!-- <el-link :underline="false" type="success" @click.stop='goDetail({row})'>{{row.title}}</el-link> -->
            </template>
          </vxe-table-column>
          <vxe-table-column field="noExecuteForm" min-width="250" title="未执行表格">
            <template #default="{row}">
              <el-link
                v-if="!row.expandRowFlag"
                :underline="false"
                class="plan_table"
                type="danger"
              >{{JSON.parse(row.nonExecutedTitle || []).length > 1 ? '&lt;&lt;' + JSON.parse(row.nonExecutedTitle || [])[0] +  '&gt;&gt;' + "..." : JSON.parse(row.nonExecutedTitle || []).length === 1 ? '&lt;&lt;' + JSON.parse(row.nonExecutedTitle || [])[0] +  '&gt;&gt;' : ""}}
              </el-link>
              <div v-else>
                <el-link
                  :underline="false"
                  class="plan_table"
                  type="danger"
                  v-for="item in JSON.parse(row.nonExecutedTitle || [])"
                  :key="item"
                  :label="item"
                  :value="item"
                  >{{ '&lt;&lt;' + item + '&gt;&gt;' }}</el-link
                >
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="" title="操作" fixed width="100" class-name="operation">
            <template #default="scope">
              <el-button
                v-if="JSON.parse(scope.row.nonExecutedTitle).length && $auth(that, 'Remind')"
                size="mini"
                type="primary"
                @click.stop="call(scope.row)"
                :disabled="scope.row.oecDimission === 1"
                >提醒</el-button
              >
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div class="page-con atb-flex atb-flex-justify-end">
        <vxe-pager
          background
          :current-page.sync="page.PageIndex"
          :page-size.sync="page.PageSize"
          :total="total"
          height="100%"
          @page-change="handlePageChange"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Total']"
        >
        </vxe-pager>
      </div>
    </div>
  </div>
</template>
<script>
import XEUtils from 'xe-utils';
import _ from 'lodash'
export default {
  components: {
    selecter: () => import('@/component/global/customerSelect'),
  },
  name: 'executeForm',
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            },
          },
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            },
          },
          {
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            },
          },
        ],
      },
      searchParam: {
        Week: null,
        Status: null,
        Key: null,
        FinishDate: '',
        AuthType: 0,
      },
      page: {
        PageIndex: 1,
        PageSize: 10,
      },
      category: {
        day: '日',
        week: '周',
        month: '月',
        year: '年',
      },
      total: 0,
      tableData: [],
      that: this,
      expandedData: [],
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      depList: [],
      department: '',
      departmentNo: '',

      authTypeList: [
        { label: '直属下级', value: 0 },
        { label: '全部下级', value: 1 },
        { label: '数据权限', value: 2 },
        { label: '全部', value: 3 },
      ]
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.getDep();
    this.getList(1);
  },
  methods: {
    expandRow({ row, rowIndex }) {
      this.tableData[rowIndex].expandRowFlag = !this.tableData[rowIndex].expandRowFlag;
      this.$refs.executeForm.updateData(this.tableData);
    },
    getList(page) {
      this.page.PageIndex = page;
      const queryWhere = _.cloneDeep(this.searchParam);
      if (queryWhere.FinishDate && queryWhere.FinishDate.length > 0) {
        queryWhere.StartTime = this.formatDate(this.searchParam.FinishDate[0], 'yyyy-MM-dd');
        queryWhere.EndTime = this.formatDate(this.searchParam.FinishDate[1], 'yyyy-MM-dd');
        delete queryWhere.FinishDate;
      }
      const pageParam = { SkipCount: (this.page.PageIndex - 1) * this.page.PageSize, MaxResultCount: this.page.PageSize };
      let param = Object.assign({department: this.departmentNo}, queryWhere, pageParam);
      this.$ajax.get(this.$api.manage.executeForm.list, param).then((res) => {
        this.tableData = res.data.rows;
        this.tableData.forEach(val => {
          val.expandRowFlag = false;
        })
        this.total = res.data.total;
      });
    },
    async getDep() {
      await this.$ajax.get(this.$api.Identity.Categord.dep, {}).then((res) => {
        this.depList = res.data || [];
        const obj = {};
        this.depList.forEach((v) => {
          const objClone = _.cloneDeep(obj);
          (objClone.id = v.id), (objClone.code = v.code), (objClone.label = v.displayName);
          if (v.parentId === null) {
            this.expandedData.push(v.id);
            objClone.children = this.depList.filter((t) => t.parentId === v.id);
            this.generateMenu(objClone.children);
            this.treeData.push(objClone);
            this.copyTreeData = _.cloneDeep(this.treeData);
          }
        });
      });
    },
    generateMenu(chs) {
      chs.forEach((v) => {
        v.label = v.displayName;
        v.children = this.depList.filter((t) => t.parentId === v.id);
        this.generateMenu(v.children);
      });
    },
    filterDeptNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    foldHistoryTree() {
      let treeList = this.treeData;
      //关键代码
      for (let i = 0; i < treeList.length; i++) {
        this.$refs.tree.store.nodesMap[treeList[i].id].expanded = false;
      }
    },
    handleCheckChange(data, checked) {
      if (checked === true) {
        this.checkId = data.id;
        this.departmentNo = data.code;
        this.department = data.label;
        this.$refs.tree.setCheckedKeys([data.id]);
      } else {
        if (this.checkId === data.id) {
          this.checkId = '';
          this.departmentNo = '';
          this.department = '';
          this.$refs.tree.setCheckedKeys([]);
        }
      }
    },
    getChildrenMenu(depData = []) {
      let depTree = [];
      depData.forEach((t) => {
        if (t.label.indexOf(this.department) != -1) {
          depTree.push(t);
        } else {
          if (t.children && t.children && t.children.length) {
            t.children = this.getChildrenMenu(t.children);
            if (t.children && t.children.length) {
              depTree.push(t);
            }
          }
        }
      });
      return (this.treeData = depTree);
    },
    handledHide() {
      this.$nextTick(() => {
        if (!this.$refs.tree.getCheckedKeys().length) {
          this.department = '';
        }
      });
    },
    formatDate(value, format) {
      return XEUtils.toDateString(value, format);
    },
    handlePageChange({ currentPage }) {
      this.getList(currentPage);
    },
    exportExcel() {
      const queryWhere = _.cloneDeep(this.searchParam);
      if (queryWhere.FinishDate && queryWhere.FinishDate.length > 0) {
        queryWhere.StartTime = this.formatDate(this.searchParam.FinishDate[0], 'yyyy-MM-dd');
        queryWhere.EndTime = this.formatDate(this.searchParam.FinishDate[1], 'yyyy-MM-dd');
        delete queryWhere.FinishDate;
      }
      let select = this.$refs.executeForm.getCheckboxRecords();
      const res = select.map(val => val.wkNo).join(",");
      this.$ajax
        .get(this.$api.export.executeFormListTaskExport, Object.assign(queryWhere, {department: this.departmentNo, ExportWkNos: res}))
        .then((res) => {
          if (res.code === 0) {
            this.$router.push({
              path: '/manage/export-task/index',
            });
          }
        })
        .catch(() => {});
    },
    goDetail({ row }) {
      console.log(row);
      this.$router.push({
        path: '/personal/year-plan/detail',
        query: {
          id: row.id,
          status: row.status,
        },
      });
    },
    filterData(res) {
      return res && res.data && res.data.rows;
    },
    openTable(row) {
      if (row.Category === 'year') {
        this.$router.push({
          path: '/personal/year-plan/Detail',
          query: {
            id: row.WorkId,
            editStatus: 'manage'
          },
        });
      } else if (row.Category === 'month') {
        this.$router.push({
          path: '/personal/month/detail',
          query: {
            id: row.WorkId,
            editStatus: 'manage'
          },
        });
      } else if (row.Category === 'week') {
        this.$router.push({
          path: '/personal/week/detail',
          query: {
            id: row.WorkId,
            editStatus: 'manage'
          },
        });
      } else if (row.Category === 'day') {
        this.$router.push({
          path: '/personal/day/detail',
          query: {
            id: row.WorkId,
          },
        });
      }
    },
    openOEC(row) {
      this.$router.push({
        path: '/manage/execute-form/detail',
        query: {
          wkNo: row.wkNo,
          wkName: row.wkName,
          isSub: this.searchParam.AuthType === 0
        },
      });
    },
    call(row) {
      let title = '';
      row.nonExecutedTitle &&
        JSON.parse(row.nonExecutedTitle).forEach((t) => {
          title += '<<' + t + '>> ';
        });
      this.$ajax.get(this.$api.manage.executeForm.Remind, { WkNo: row.wkNo, Title: title }).then((res) => {
        if (res.code === 0) {
          this.$message.success('提醒成功');
          this.getList(this.page.PageIndex);
        }
      });
    },
  },
  activated() {},
  watch: {
    department: {
      handler(val) {
        this.$refs.tree && this.$refs.tree.filter(val);
        if (!val) {
          this.departmentNo = "";
          if (this.$refs.tree) {
            setTimeout(() => {
              const depTree = _.cloneDeep(this.copyTreeData);
              this.treeData = depTree;
            }, 10)
            this.$refs.tree.setCheckedKeys([]);
          }
        }
      },
      immediate: true,
    },
  },
};
</script>
<style scoped lang="scss">
.execute-form {
  height: 100%;
  .search {
    .el-date-editor--daterange {
      width: 360px;
      border-radius: 10px;
    }
  }
  .atb-content-bg {
    margin-top: 0px;
    padding: 20px;
    flex: 1;
  }
  ::v-deep .el-tag {
    padding: 0 8px;
    width: auto;
  }
  .plan_table {
    padding: 0 5px;
  }
  .el-link--danger {
    cursor: auto;
  }
  .el-button.is-disabled, .el-button.is-disabled:hover, .el-button.is-disabled:focus {
    background-color: #f2f2f2!important;
    border-color: #ebeef5!important;
    color: #c0c4cc;
  }
}
.footer {
  text-align: right;
  margin-top: 20px;
  .select-all-program {
    margin-right: 20px;
  }
}
.declare-dep {
  height: 350px;
  width: 350px;
  overflow: auto;
}
</style>
